export async function getConfig() {
  return {
    env: {
      isMobileApp: process.env.MOBILE_APP || false,
    },

    core: {
      websocket: false,
    },

    app: {
      // Канонический origin СТРАНИЦ сайта (canonical/og:url/alternate в martyrs App.vue).
      // Литерал, НЕ process.env: getConfig() выполняется и на клиенте.
      url: 'https://dobroverse.com',
      support: {
        url: 'https://t.me/support'
      },
      // Ключи og.* и twitter.* обязательны: App.vue (martyrs) подставляет их в
      // мета-теги напрямую, и без словаря в разметку уходит имя ключа —
      // ссылка в мессенджере показывала «meta.twitter.title».
      // Картинки ссылки — те же обязательные ключи og.image и twitter.image, и
      // у каждого языка своя: на обложке текст, и русская ссылка с английским
      // макетом выглядит как чужая.
      messages: {
        en: {
          meta: {
            title: 'Dobroverse — one pass for Phuket',
            description: 'Dobro Pass for Phuket: local places and perks for two, for a trip of up to 30 days. Free arrival prep, Fast Track and transfers in the catalog.',
            keywords: 'Phuket, Dobro Pass, Dobro Black, Phuket perks, Fast Track, airport transfer, travel to Thailand',
            og: {
              title: 'Dobroverse — one pass for Phuket',
              description: 'Local places and perks for two, for a trip of up to 30 days. Arrival services in the catalog.',
              image: '/favicon/cover.jpg',
            },
            twitter: {
              title: 'Dobroverse — one pass for Phuket',
              description: 'Local places and perks for two, for a trip of up to 30 days. Arrival services in the catalog.',
              image: '/favicon/cover.jpg',
              card: 'summary_large_image',
            },
          },
        },
        ru: {
          meta: {
            title: 'Dobroverse — один пасс для Пхукета',
            description: 'Dobro Pass для Пхукета: местные места и скидки на двоих, на поездку до 30 дней. Бесплатная подготовка к приезду, Fast Track и трансферы в каталоге.',
            keywords: 'Пхукет, Dobro Pass, Dobro Black, скидки на Пхукете, Fast Track, трансфер из аэропорта, поездка в Таиланд',
            og: {
              title: 'Dobroverse — один пасс для Пхукета',
              description: 'Местные места и скидки на двоих, на поездку до 30 дней. Услуги приезда в каталоге.',
              image: '/favicon/cover-ru.jpg',
            },
            twitter: {
              title: 'Dobroverse — один пасс для Пхукета',
              description: 'Местные места и скидки на двоих, на поездку до 30 дней. Услуги приезда в каталоге.',
              image: '/favicon/cover-ru.jpg',
              card: 'summary_large_image',
            },
          },
        }
      }
    },

    modules: {
      auth: {
        loader: () => import('@ozdao/martyrs/modules/auth/client'),
        routes: ['/'],
        priority: 'high',
        dependencies: []
      },
    },
  };
}
